// macOS / Windows glyphs for plugin download buttons — shared by the Account
// page's "Download Plugin" section and the post-checkout Purchase Successful
// screen so both stay visually identical.

export const AppleIcon = () => (
    <svg width="14" height="16" viewBox="0 0 14 16" fill="currentColor" aria-hidden="true">
        <path d="M11.53 8.48c-.02-2.05 1.68-3.03 1.75-3.08-.95-1.39-2.44-1.58-2.97-1.6-1.26-.13-2.47.74-3.11.74-.64 0-1.63-.72-2.68-.7-1.38.02-2.65.8-3.36 2.03-1.43 2.48-.37 6.16 1.03 8.17.68.99 1.49 2.1 2.56 2.06 1.03-.04 1.42-.66 2.66-.66 1.24 0 1.59.66 2.68.64 1.11-.02 1.81-1 2.48-2 .78-1.15 1.1-2.26 1.12-2.32-.02-.01-2.15-.82-2.16-3.28zM9.5 2.5C10.06 1.82 10.44.87 10.34 0c-.81.03-1.79.54-2.37 1.22-.52.6-.98 1.57-.86 2.5.9.07 1.83-.46 2.39-1.22z" />
    </svg>
);

export const WindowsIcon = () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor" aria-hidden="true">
        <path d="M0 1.9L5.7 1.1V6.7H0V1.9ZM6.4 1L14 0V6.7H6.4V1ZM0 7.4H5.7V13L0 12.1V7.4ZM6.4 7.4H14V14L6.4 13V7.4Z" />
    </svg>
);
